<modal-container
  [headerIconClass]=""
  [headerTitle]="('add' | translate) + ' ' + orderItem?.product?.fullName"
  [modalHeaderBgColorClass]="'header-class bg_green'"
  [modalBodyBgColorClass]="'bg_green'"
  [modalFooterBgColorClass]="'bg_green'"
  [isLargeModal]="true"
>
  <ng-container class="modal-button-show">
    @if (!isAddingNew) {
      <btn
        [icon]="'far-pencil'"
        [title]="'edit' | translate"
        [classes]="['me-2', 'btn-edit', 'btn-sm']"
        (onEvent)="showProductOnChildModal()"
      ></btn>
    }
  </ng-container>
  <ng-container class="modal-body-content">
    <div class="container-fluid ps-0 pe-0">
      <div class="stock-operation-card--content">
        <div class="card" style="padding: 26px">
          <div class="row">
            <form-row-input
              class="col-4"
              [label]="'product.code'"
              [icon]="'far-tag'"
              [model]="orderItem?.product?.code"
              [inputDisabled]="true"
              data-cy="code"
            ></form-row-input>
            <form-row-input
              class="col-8"
              [label]="'product.ean'"
              [icon]="'far-barcode'"
              [translateBarcode]="true"
              [model]="orderItem?.product?.ean"
              [appendBtnClasses]="['btn', 'btn-ean']"
              [inputDisabled]="true"
              data-cy="ean"
            >
            </form-row-input>
          </div>
          <div class="row">
            <form-row-input
              class="col-4"
              [inputType]="'number'"
              [label]="'quantity'"
              [icon]="'far-list'"
              [model]="orderItem?.quantity"
              (modelChange)="orderItem.quantity = $event"
            ></form-row-input>
            <form-row-input
              class="col-4 align-items-center"
              [label]="'purchasePrice'"
              [icon]="'far-money-bill'"
              [replaceComma]="true"
              [model]="orderItem?.purchasePrice"
              (modelChange)="orderItem.purchasePrice = $event"
              [requiredCssClass]="!loading && !orderItem.purchasePrice && orderItem.purchasePrice !== 0"
            ></form-row-input>
            <form-row-select
              class="col-4"
              [label]="'currency'"
              [icon]="'far-money-bill-alt'"
              [options]="queryCurrencies.data()"
              [model]="orderItem.currency"
              (modelChange)="currencyChanged($event)"
              [bindToObject]="true"
            >
            </form-row-select>
          </div>
          <div class="row">
            <form-row-textarea
              class="col-12"
              [label]="'note'"
              [icon]="'far-list'"
              [model]="orderItem?.note"
              [rows]="4"
              (modelChange)="orderItem.note = $event"
            ></form-row-textarea>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container class="modal-footer-content">
    <btn
      [btnType]="'submit'"
      [icon]="'far fa-pencil'"
      [label]="'add' | translate"
      [classes]="['btn-first']"
      (click)="addProduct()"
      [title]="'add'"
      [isLoading]="loading"
    ></btn>
  </ng-container>
</modal-container>
